// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--3SjXQt6lt","JSONdownload":"JSONdownload--RiRklkA5k","jsonupload":"jsonupload--fsZ2kss22"};